import { render } from "./ColorForm.vue?vue&type=template&id=d41f7cd6"
import script from "./ColorForm.vue?vue&type=script&lang=js"
export * from "./ColorForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__